export default __webpack_public_path__ + "static/media/promos.3f97b162.jpg";